module.exports = __webpack_public_path__ + "static/img/def.17ae5fe5.jpg";